// JavaScript Document
$(function () {
/*
======================
BODY FADE IN
======================
*/

	setTimeout(function () {
		$("body").removeClass("fade-out");
	}, 320);

	setTimeout(function () {
		$("body").addClass("loaded");
		$("#page-loader").fadeOut(900);
		$(".page-wrap").removeClass("fade-out");
	}, 1200);

/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

	if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
		$("html").addClass("safari");
	}

	/*
================================
SCROLL ANIMATIONS (WOW JS)
================================
*/

	var wow = new WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
		scrollContainer: null,
		resetAnimation: false,
	});
	wow.init();

	/*
=========================
OBJECT FIT
=========================
*/

	$(function () {
		objectFitImages("img.object-fit");
	});

	/*
=====================
TEL LINKS
=====================
*/

	//Disable on desktop (non touch)...
	$(".no-touch a.tel").on("click", function (e) {
		e.preventDefault();
	});

	/*
=====================
TABLE WRAPPER
=====================
*/

	$("table").wrap('<div class="table-wrap"></div>');

	/*
======================
IFRAME WRAPPER
======================
*/

	$(".page-section iframe").wrap('<div class="iframe-wrap"></div>');

	/*
===============================
FIXED HEADER
===============================
*/

	//add header class
	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 1) {
			$("#masthead").addClass("scrolled");
		} else {
			$("#masthead").removeClass("scrolled");
		}
	});

	//check page position and add class if not at the top of page on load
	var pagePostion = $(window).scrollTop();

	if (pagePostion > 1) {
		$("#masthead").addClass("scrolled");
	} else {
		$("#masthead").removeClass("scrolled");
	}

	/*
======================
HAMBURGER MENU
======================
*/

	//open menu
	$(".menu-toggle").on("click", function (e) {
		e.stopPropagation();
		$("body").toggleClass("main-navigation--open");
		$(this).toggleClass("active");
		$(".main-navigation").toggleClass("active");
	});

	//close menu when clicking outside of menu
	$(document).on("click", function (e) {
		// if click is NOT inside .main-navigation or .menu-toggle
		if (!$(e.target).closest(".main-navigation, .menu-toggle").length) {
			$("body").removeClass("main-navigation--open");
			$(".menu-toggle").removeClass("active");
			$(".main-navigation").removeClass("active");
		}
	});

	$("#main-navigation .menu-item-has-children").append('<div class="menu-expand"><i class="text-deepPurple fa-sharp fa-solid fa-chevron-down"></i></div>');

	$(".menu-expand").on("click", function () {
		$(this).toggleClass("active");
		$(this).parent("li").toggleClass("active");
		$(this).parent("li").toggleClass("sub-menu-open");
		$(this).parent("li").find("> .sub-wrap").slideToggle(600);
	});

	//hover class
	$("#main-navigation ul li")
		.on("mouseenter", function () {
			$(this).addClass("active-hover");
		})
		.on("mouseleave", function () {
			$(this).removeClass("active-hover");
		});

	$(".main-menu .close").on("click", function () {
		$(".hamburger").removeClass("active");
		$(".main-menu").removeClass("active");
	});

	/*
================================
MENU AIM
================================
*/

	var $menu = $(".main-menu .desktop-menu ul");

	$menu.menuAim({
		activate: activateSubmenu,
		deactivate: deactivateSubmenu,
	});

	function activateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.children("a").addClass("hover");
		$submenu.css({display: "block"});
	}

	function deactivateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.find("a").removeClass("hover");
		$submenu.css("display", "none");
	}

	$(document).click(function () {
		$(".main-menu .desktop-menu ul li a.hover").removeClass("hover");
	});

/*
=======================================
PRODUCTS MENU
=======================================
*/

	$(".products-menu .toggle").on("click", function () {
		$(this).toggleClass("active");
		$(".products-menu nav").toggleClass("active");
		$(".products-menu nav").slideToggle(500);
	});

	/*
=======================================
RESPONSIVE DATA TABLES
======================================
*/

	var tables = document.querySelectorAll(".page-section .table-wrap table");
	for (var a = 0; a < tables.length; a++) {
		var headertext = [];
		var headers = tables[a].querySelectorAll("thead td"),
			tablebody = tables[a].querySelector("tbody");

		for (var i = 0; i < headers.length; i++) {
			var current = headers[i];
			headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
		}
		for (var i = 0, row; (row = tablebody.rows[i]); i++) {
			for (var j = 0, col; (col = row.cells[j]); j++) {
				col.setAttribute("data-th", headertext[j]);
			}
		}
	}

			/*
=================================
FANCYBOX
=================================
*/

	$("[data-fancybox]").fancybox({
		autoFocus: false,
		touch: false,
		compact: false,
		beforeShow: function () {
			$("html").addClass("fancybox-opened");
			$("body").css("overflow", "hidden");
		},
		afterClose: function () {
			$("html").removeClass("fancybox-opened");
			$("body").css("overflow", "");
		},
	});

	// Prevent clicking from causing a scroll
	$("[data-fancybox]").on("click", function (e) {
		e.preventDefault();
	});

	/*
======================================
SMOOTH SCROLL
======================================
*/

	// SMOOTH SCROLLING FROM ANOTHER PAGE TO CORRECT ID
	//START AT TOP OF PAGE AND SCROLL DOWN ALWAYS
	if (window.location.hash) {
		setTimeout(function () {
			$("html, body").scrollTop(0).show();
			$("html, body").animate(
				{
					scrollTop: $(window.location.hash).offset().top - 0,
				},
				1000
			);
		}, 0);
	} else {
		$("html, body").show();
	}

	//SMOOTH SCROLLING
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not("[data-fancybox]")
		.click(function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 0,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
						}
					);
				}
			}
		});

	/*
=========================
ACCORDION
=========================
*/

	$(".accordion-item .toggle-header").on("click", function () {
		$(this).parent(".accordion-item").toggleClass("active");
		$(this).next(".toggle-content").slideToggle("slow");
	});

	/*
=========================
UP ARROW
=========================
*/

	$(".up").on("click", function (event) {
		event.preventDefault();
		$("body,html").animate({scrollTop: 0}, 1000);
	});

	/*
==========================
BUTTONS
==========================
*/

	if ($("p .button").length > 0) {
		$("p").each(function () {
			if ($(this).find(".button").length === 2) {
				$(this).addClass("two-buttons");
			}
		});
	}

	/*
==========================
SLIDERS
==========================
*/

	//Banner Slider
	var swiper1 = new Swiper(".banner-slider .swiper", {
		/*navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},*/
		autoplay: true,
		loop: true,
		effect: "fade",
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: true,
		centeredSlidesBounds: true,
		navigation: false,
		pagination: {
			el: ".banner-slider .swiper-pagination",
		},
	});

	//Small Image slider

	var swiper4Slides = new Swiper(".swiper-4-slides", {
		slidesPerView: 1,
		spaceBetween: 20,
		autoplay: true,
		loop: false,
		spaceBetween: 40,
		navigation: {
			nextEl: ".carousel-section .swiper-button-next",
			prevEl: ".carousel-section .swiper-button-prev",
		},
		pagination: {
			el: ".carousel-section .swiper-pag",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 40,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 40,
			},
		},
	});

	var swiper2 = new Swiper(".swiper-6-slides", {
		slidesPerView: 3,
		spaceBetween: 10,
		navigation: {
			nextEl: ".small-image-slider .swiper-button-next",
			prevEl: ".small-image-slider .swiper-button-prev",
		},
		pagination: {
			el: ".small-image-slider .swiper-pag",
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 50,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 70,
			},
			1600: {
				slidesPerView: 6,
				spaceBetween: 100,
			},
		},
	});

	const thumbSlider = new Swiper('.thumb-slider', {
		spaceBetween: 10,
		slidesPerView: 5,
		freeMode: true,
		watchSlidesProgress: true,
	});

	const mainSlider = new Swiper('.gallery-slider', {
		spaceBetween: 10,
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: ".swiper-pag",
		},
		thumbs: {
			swiper: thumbSlider,
		},
	});

	//Large Image Slider
	var swiper3 = new Swiper(".mySwiper3", {
		spaceBetween: 20,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: ".large-image-slider .swiper-button-next",
			prevEl: ".large-image-slider .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-2",
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
		},
	});

	var swiper4 = new Swiper(".mySwiper4", {
		slidesPerView: 1,
		// thumbs: {
		// 	swiper: swiper3,
		// },
	});

	swiper4.on("slideChange", () => {
		swiper3.slideTo(swiper4.activeIndex);
	});

	//reviews carousel
	var swiper2 = new Swiper(".reviews-carousel", {
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: false,
		centeredSlidesBounds: false,
		loop: true,
		navigation: {
			nextEl: ".reviews-carousel .swiper-button-next",
			prevEl: ".reviews-carousel .swiper-button-prev",
		},
		pagination: {
			el: ".reviews-carousel .swiper-pagination",
		},
		breakpoints: {
			680: {
				slidesPerView: 1,
				spaceBetween: 40,
			},
			850: {
				slidesPerView: 2,
				spaceBetween: 80,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 80,
			},
		},
	});

	//Single Page Related Content
	var swiper5 = new Swiper(".related__swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: ".reviews .swiper-button-next",
			prevEl: ".reviews .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-4",
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1600: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	});

	/*
==========================
RECAPTCHA FADEOUT
==========================
*/

	$(window).on("scroll", function () {
		var documentHeight = $(document).height();
		var windowHeight = $(window).height();
		var scrollPosition = $(window).scrollTop();

		if (documentHeight - (windowHeight + scrollPosition) < 100) {
			$(".grecaptcha-badge").addClass("fade");
		} else {
			$(".grecaptcha-badge").removeClass("fade");
		}
	});

/*
=================================
TICKET CTA BGS
=================================
*/

    function updateTicketBeforeAfterColors($element) {
        function getBgClass($el) {
            if (!$el.length) return null;
            var classes = $el.attr('class') || "";
            return classes.split(/\s+/).find(c => c.startsWith('bg-')) || null;
        }

        //update the classes
        var prevBgClass = getBgClass($element.prev('section'));
        var nextBgClass = getBgClass($element.next('section'));

        if (prevBgClass) {
            $element.addClass('before-' + prevBgClass);
        }

        if (nextBgClass) {
            $element.addClass('after-' + nextBgClass);
        }

        //update the styles
        var prevBgColor = $element.prev('section').css('background-color') || 'transparent';
        var nextBgColor = $element.next('section').css('background-color') || 'transparent';

		//check if we are on a product term page
		if ($('body').hasClass('tax-product-type')) {
			prevBgColor = $element.prev('.product-terms').find('.product-type-child-block').last().css('background-color') || 'transparent';
		}

        // Set CSS variables on the element
        $element.css({
            '--before-bg-color': prevBgColor,
            '--after-bg-color': nextBgColor
        });
    }
    updateTicketBeforeAfterColors($('.ticket-cta'));


    function updateFooterContactBeforeColor($element) {
        //update the styles
        var prevBgColor = $element.prev('section').css('background-color') || 'transparent';

        // Set CSS variables on the element
        $element.css({
            '--before-fc-bg-color': prevBgColor
        });
    }
    updateFooterContactBeforeColor($('.footer-contact'));	

	/*
===========================
MATCH HEIGHTS
===========================
*/

	$(function () {
		$("article h3.block-title").matchHeight({property: "height"});
		$("article .block-content").matchHeight({property: "height"});
		$("article .block-content .excerpt").matchHeight({property: "height"});
	});	

	/*
================================
ANIMATIONS
================================
*/


	function isInViewport($el) {
		const rect = $el[0].getBoundingClientRect();
		return (
			rect.top <= $(window).height() &&
			rect.bottom >= 0
		);
	}

	function checkSlideIn() {
		const $box = $('.car');
		if (isInViewport($box)) {
			$box.addClass('slide-in');
			$(window).off('scroll', checkSlideIn); // Stop listening after triggering
		}
	}

    // Run on scroll and initial load
    $(window).on('scroll', checkSlideIn);
    checkSlideIn(); // In case it's already visible



	/*
==========================
AJAX
==========================
*/

	//LOAD MORE CHARACTERS
	$(".our-characters .posts-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.post-count").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_characters",
				already_loaded: loaded,
			},
			beforeSend: function () {
				$(".our-characters .posts-container .load-more-posts").fadeTo(600, 0, function () {
					$(".our-characters .posts-container .load-more-posts").html('<div class="load animation-loading"></div>'); 
				});
				$(".our-characters .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".our-characters .posts-container .load-more-posts")
					.delay(1000)
					.fadeOut(700, function () {
						$(".our-characters .posts-container .load-more-posts").remove();
						$(".our-characters .posts-container").append(data);
					});
			},
		});
	});

	//LOAD MORE TEAM MEMBERS
	$(".our-team .posts-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.post-count").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_team",
				already_loaded: loaded,
			},
			beforeSend: function () {
				$(".our-team .posts-container .load-more-posts").fadeTo(600, 0, function () {
					$(".our-team .posts-container .load-more-posts").html('<div class="load animation-loading"></div>'); 
				});
				$(".our-team .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".our-team .posts-container .load-more-posts")
					.delay(1000)
					.fadeOut(700, function () {
						$(".our-team .posts-container .load-more-posts").remove();
						$(".our-team .posts-container").append(data);
					});
			},
		});
	});

	//LOAD MORE POSTS
	$(".news-posts .posts-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.post-count").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_posts",
				already_loaded: loaded,
			},
			beforeSend: function () {
				$(".news-posts .posts-container .load-more-posts").fadeTo(600, 0, function () {
					$(".news-posts .posts-container .load-more-posts").html('<div class="load"></div>');
				});
				$(".news-posts .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".news-posts .posts-container .load-more-posts")
					.delay(1000)
					.fadeOut(700, function () {
						$(".news-posts .posts-container .load-more-posts").remove();
						$(".news-posts .posts-container").append(data);
					});
			},
		});
	});
}); //end document.ready
